import type { AnalyticsClient, CookieClient } from '@/scopes/common/domain/types';
import { createLoggedUserEvent } from '@/domain/header/analytics';
import { parseUserCookie } from './parseUserCookie';
import { type QueryStringClient } from '../../infrastructure/query-strings/queryStringClient';

interface Dependencies {
  analyticsClient: AnalyticsClient;
  cookieClient: CookieClient;
  queryStringClient: QueryStringClient;
}

export default function useCases({ analyticsClient, cookieClient, queryStringClient }: Dependencies) {
  function reactPageLoaded() {
    const userData = cookieClient.get('user-data');
    const { userId, isLoggedIn } = parseUserCookie(userData);
    analyticsClient.sendEvent(createLoggedUserEvent({ loggedIn: isLoggedIn, userId }));
  }

  async function loginSunwebCEUser() {
    const user = queryStringClient.getValue('usr');
    const pass = queryStringClient.getValue('pas');
    queryStringClient.remove('usr');
    queryStringClient.remove('pas');

    if (!user || !pass) return false;

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/CeLoginApi/CeLogin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userParam: user, passParam: pass }),
      credentials: 'include',
    });

    if (!response.ok) return false;

    const { isValidCeUser = false } = await response.json();
    return isValidCeUser;
  }

  return {
    reactPageLoaded,
    loginSunwebCEUser,
  };
}
